import { toLocale, Locale } from '@peloton/internationalize/models/locale';
import { isDefined } from '@peloton/types/isDefined';
import { useReduxState } from '@engage/redux/hooks';
import { getDisplayLanguage } from '@engage/settings/redux';
import { toSupportedBrowserLanguage } from './toSupportedBrowserLanguage';

export const useLocale = () => {
  try {
    const displayLanguage = useReduxState(getDisplayLanguage);

    return isDefined(displayLanguage)
      ? toLocale(displayLanguage)
      : toLocale(toSupportedBrowserLanguage());
  } catch (_) {
    return Locale.Default;
  }
};
